import React from 'react';
import { DefaultButton, PrimaryButton, Stack, Text } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import { useNavigate } from 'react-router';

const CreateNewOrg: React.FC<{ setRemoveOrgOpened: (value: boolean) => void }> = ({ setRemoveOrgOpened }) => {
    const routerHistory = useNavigate();
    return (
        <Stack styles={{ root: { minHeight: 300, position: 'relative' } }}>
            <Text variant="xLargePlus" styles={{ root: { marginLeft: 16, marginBottom: 30 } }}>
                {IvicosStrings.startSetupButtonTitle}
            </Text>
            <Stack tokens={{ childrenGap: 20 }} styles={{ root: { marginLeft: 16, marginBottom: 10 } }}>
                <Text variant="medium">{IvicosStrings.createNewBuildingDescriptions.description1}</Text>
                <Text variant="medium">{IvicosStrings.createNewBuildingDescriptions.description2}</Text>
                <Text variant="medium">{IvicosStrings.createNewBuildingDescriptions.description3}</Text>
            </Stack>

            <Stack horizontalAlign="end" horizontal style={{ gap: '15px', position: 'absolute', bottom: 0, right: 0 }}>
                <DefaultButton text={IvicosStrings.removeOrganizationButton} iconProps={{ iconName: 'Delete' }} onClick={() => setRemoveOrgOpened(true)} />
                <PrimaryButton
                    text={IvicosStrings.startSetupButtonDescription}
                    iconProps={{ iconName: 'Add' }}
                    onClick={() => {
                        routerHistory('/ivcampussetup');
                    }}
                />
            </Stack>
        </Stack>
    );
};

export default CreateNewOrg;
